import { render, staticRenderFns } from "./ModalSolicitudesInscripciones.vue?vue&type=template&id=510811e4"
import script from "./ModalSolicitudesInscripciones.vue?vue&type=script&lang=js"
export * from "./ModalSolicitudesInscripciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports